import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const RolesPermsDetailsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'RolesPermsDetails' */ './components/RolesPermsDetails'
		)
);

export default (store) => {
	return {
		path: 'roles-configuration/:roleId',
		element: <AsyncLoading component={<RolesPermsDetailsLazy />} />,
	};
};
